<template>
  <Breadcrumbs title="" main="Home" />
  <div class="container-fluid">

    <!-- Banner -->
    <div class="row">
      <div class="col-sm-12">
        <div class="section-card">
          <div class="owl-carousel owl-theme" id="owl-carousel-13">
            <swiper autoHeight: true :slides-per-view="1" :space-between="10" :autoplay="autoplay" loop="true" :pagination="{
                clickable: true,
              }" :modules="modules" :breakpoints="swiperOptions.breakpoints">
              <swiper-slide v-for="(item,index) in this.slider_banner" :key="index">
                <a :href="item.link_url" target="_blank">
                  <img :src="item.image_url" alt="" class="img-fluid modern-image">
                </a>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <!-- กิจกรรมที่กำลังเปิดขาย -->
    <div class="row mt-3">
      <div class="col-sm-12">
        <div class="section-card">
          <div class="section-card-header">
            <h2>{{ this.currentLanguage === 'en' ? 'Easy to find, Easy to get' : 'Easy to find, Easy to get' }}</h2>
          </div>
          <div class="section-card-body">
            <div v-if="loading" class="row gallery-with-description">
              <div class="col-xl-4 col-sm-6" v-for="n in 6" :key="n" style="margin-bottom: 48px; padding-left: 15px; padding-right: 15px;">
                <div class="skeleton-card">
                  <div class="skeleton-img"></div>
                  <div class="skeleton-body">
                    <div class="skeleton-line skeleton-title"></div>
                    <div class="skeleton-line skeleton-sub"></div>
                    <div class="skeleton-line skeleton-sub2"></div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="my-gallery row gallery-with-description" itemscope="">
              <figure
                class="col-xl-4 col-sm-6"
                v-for="(src, index) in this.events_on_sale"
                :key="index"
                style="position: relative; margin-bottom: 48px; padding-left: 15px; padding-right: 15px;"
              >
                <span
                  v-if="src.pin === 1"
                  style="
                    position: absolute;
                    top: 6px;
                    right: 20px;
                    background-color: red;
                    color: white;
                    font-size: 0.7em;
                    font-weight: 700;
                    padding: 2px 7px;
                    border-radius: 4px;
                    z-index: 10;
                    letter-spacing: 0.05em;
                    box-shadow: 0 1px 4px rgba(0,0,0,0.25);
                  "
                ><i class="fa fa-thumb-tack" style="margin-right: 3px; transform: rotate(35deg); display: inline-block;"></i>PIN</span>
                <a v-bind:href="src.event_key" class="event-card">
                  <img
                    style="border-top-left-radius: 0.6em; border-top-right-radius: 0.6em; border: 0px; display: block;"
                    :src="src.coverurl"
                    alt="Image description"
                    class="img-thumbnail"
                  />
                  <div class="caption" style="border-bottom-left-radius: 0.6em; border-bottom-right-radius: 0.6em; border: 0px; padding: 6px 10px 4px; margin-bottom: 0;">
                    <h4>{{ src.title }}</h4>
                    <b><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ src.event_date_text }}</b>
                    <p style="margin-bottom: 0;"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ src.eventdate }} {{ src.province }}</p>
                  </div>
                </a>
              </figure>
              <paginate
                v-if="this.total_event_onsale > this.init_page_size"
                v-model="page"
                :page-count="this.page_tab"
                :page-range="3"
                :margin-pages="4"
                :clickHandler="clickCallback"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination justify-content-center pagination-sm'"
                :page-class="'page-item'"
              ></paginate>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- กิจกรรมที่กำลังจะมาถึง -->
    <div class="row mt-3" v-if="this.events_soon.length > 0">
      <div class="col-sm-12">
        <div class="section-card">
          <div class="section-card-header">
            <h3>{{ this.currentLanguage === 'en' ? 'Upcoming events' : 'กิจกรรมที่กำลังจะมาถึง' }}</h3>
          </div>
          <div class="section-card-body">
            <div v-if="loading" class="row gallery-with-description">
              <div class="col-xl-4 col-sm-6" v-for="n in 3" :key="n" style="margin-bottom: 48px; padding-left: 15px; padding-right: 15px;">
                <div class="skeleton-card">
                  <div class="skeleton-img"></div>
                  <div class="skeleton-body">
                    <div class="skeleton-line skeleton-title"></div>
                    <div class="skeleton-line skeleton-sub"></div>
                    <div class="skeleton-line skeleton-sub2"></div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="my-gallery row gallery-with-description" itemscope="">
              <figure
                class="col-xl-4 col-sm-6"
                v-for="(src, index) in this.events_soon"
                :key="index"
                style="position: relative; margin-bottom: 48px; padding-left: 15px; padding-right: 15px;"
              >
                <a v-bind:href="src.event_key" class="event-card">
                  <img
                    style="border-top-left-radius: 0.6em; border-top-right-radius: 0.6em; border: 0px; display: block;"
                    :src="src.coverurl"
                    alt="Image description"
                    class="img-thumbnail"
                  />
                  <div class="caption" style="border-bottom-left-radius: 0.6em; border-bottom-right-radius: 0.6em; border: 0px; padding: 6px 10px 4px; margin-bottom: 0;">
                    <h4>{{ src.title }}</h4>
                    <b>{{ src.event_date_text }}</b>
                    <p style="margin-bottom: 0;">{{ src.eventdate }} {{ src.province }}</p>
                  </div>
                </a>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style scoped>
.section-card {
  background: var(--lux-surface, #fff);
  border-radius: 0.75rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.section-card-header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.section-card-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.section-card-body {
  padding: 20px;
}

.img-thumbnail {
  padding: 0 !important;
  background-color: transparent !important;
  border: none !important;
}

.caption {
  background: var(--lux-surface, #fff);
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.event-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 0.6em;
  overflow: hidden;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.28);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.event-card:hover {
  transform: translateY(-5px) scale(1.015);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.32);
  text-decoration: none;
}

figure {
  display: flex;
  flex-direction: column;
}

.modern-image {
  border-radius: 8px; /* ปรับค่าตามต้องการ */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* ปรับค่าตามต้องการ */
  transition: box-shadow 0.3s ease-in-out; /* เพิ่ม transition เพื่อความสมูทเมื่อมี interaction (optional) */
}

.modern-image:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Skeleton Loading */
.skeleton-card {
  border-radius: 0.6em;
  overflow: hidden;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
}

.skeleton-img {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
}

.skeleton-body {
  padding: 10px 12px 12px;
  background: #fff;
}

.skeleton-line {
  border-radius: 4px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  margin-bottom: 8px;
}

.skeleton-title {
  height: 18px;
  width: 85%;
}

.skeleton-sub {
  height: 13px;
  width: 55%;
}

.skeleton-sub2 {
  height: 13px;
  width: 70%;
  margin-bottom: 0;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";

import { useCartStore } from "../../store/modules/cart";
import axios from "axios";
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";
import VuejsPaginateNext from "../../components/Paginate.vue";
export default {
  components: {
    paginate: VuejsPaginateNext,Swiper, SwiperSlide,
  },
  setup() {
    const siteData = reactive({
      title: process.env.VUE_APP_SYSTEM_TITLE || '',
      description: process.env.VUE_APP_SYSTEM_DESCRIPTION || ``,
      keywords: process.env.VUE_APP_SYSTEM_KEYWORDS ||   ``,
      image:  process.env.VUE_APP_WEBSITE_IMAGE || '',
    })

    useHead({
      // Can be static or computed this.eventDetails.title
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },
        ],
     
    });

    const cart_store = useCartStore();
    cart_store.loadFromLocalStorage();
    return { cart_store,
      autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            swiperOptions: {
               //breakpoints: { slidesPerView: 1 } ,
               loop: true
            },
     };
  },
  data() {
    return {
      modules: [Pagination, Autoplay],
      events_on_sale: [],
      events_soon: [],
      loading: true,
      page: 1,
      init_page_size: 21,
      page_tab: 0,
      total_event_onsale: 0,
      currentLanguage: 'th',
      slider_banner:[]
    };
  },
  async created() {
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
    let result = await this.getEvents();
    if (result.status === "success") {
      this.events_on_sale = result.body;
      this.loading = false;
      this.getSliderBanner();
      this.getEventsPage();
      this.getEventsSoon();
    } else {
      this.loading = false;
      alert("พบข้อผิดพลาด ลองใม่อีกครั้ง");
    }
  },
  async mounted(){
    this.currentLanguage = localStorage.getItem('currentLanguage');
    //let result = await this.getEvents();
    // if (result.status === "success") {
    //   this.events_on_sale = result.body;
    //   this.loading = false;
    //   this.getSliderBanner();
    //   this.getEventsPage();
    //   this.getEventsSoon();
    // } else {
    //   this.loading = false;
    //   alert("พบข้อผิดพลาด ลองใม่อีกครั้ง");
    // }
  },
  methods: {
    async getEvents() {
      let data = {
        page: 1,
        page_size: this.init_page_size,
      };
      const res = await axios.post("/v1/events/pagination", data);
      return res.data;
    },
    async getSliderBanner() {
      const res = await axios.get("/v1/events/slider-banner");
      console.log(res.data)
      this.slider_banner = res.data.body;
    },
    async getEventsPage() {
      let data = {
        event_status: "ON_SALE",
      };
      const pagination_count = await axios.post(
        "/v1/events/pagination-count",
        data
      );
      this.total_event_onsale = pagination_count.data[0].event_count;
      this.page_tab = Math.round(
        this.total_event_onsale / this.init_page_size + 0.5
      );
    },
    async clickCallback(pageNum) {
      let data = {
        page: pageNum,
        page_size: this.init_page_size,
        total_event_onsale: this.total_event_onsale,
        page_tab: this.page_tab,
      };
      const response = await axios.post("/v1/events/pagination", data);

      this.events_on_sale = response.data.body;
    },
    async getEventsSoon() {
      const res = await axios.get("/v1/events/soon");
      this.events_soon = res.data;
    },
  },
};
</script>


    